/*
 Copyright (c) 2017 Wells Fargo. 455 Market St., San Francisco, CA 94105 All rights reserved.

 This software is the confidential and proprietary information of Wells Fargo
 bank. ('Confidential Information'). You shall not disclose such Confidential
 Information and shall use it only in accordance with the terms of the license
 agreement you entered into with WellsFargo.

 Author: Thomas Barry

 Description:
 */
export var SESSION_TIMEOUT = 'SESSION_TIMEOUT';
export var SESSION_LOGOFF = 'SESSION_LOGOFF';
export var LOGOFF_BACK_NAVIGATION_CONFIRMATION_REQUEST = 'LOGOFF_BACK_NAVIGATION_CONFIRMATION_REQUEST';
export var LOGOFF_REQUEST_CONFIRMATION = 'LOGOFF_REQUEST_CONFIRMATION';
export var LOGOFF_CONFIRMATION_SHOW = 'LOGOFF_CONFIRMATION_SHOW';
export var LOGOFF_CONFIRMATION_HIDE = 'LOGOFF_CONFIRMATION_HIDE';
export var SESSION_TIMEOUT_WARNING_SHOW = 'SESSION_TIMEOUT_WARNING_SHOW';
export var SESSION_TIMEOUT_WARNING_HIDE = 'SESSION_TIMEOUT_WARNING_HIDE';
export var SESSION_TIMEOUT_WARNING_DISMISS = 'SESSION_TIMEOUT_WARNING_DISMISS';
export var sessionTimeout = function sessionTimeout() {
  return {
    type: SESSION_TIMEOUT
  };
};
export var sessionLogoff = function sessionLogoff() {
  return {
    type: SESSION_LOGOFF
  };
};
export var requestBackNavigationLogoffConfirmation = function requestBackNavigationLogoffConfirmation(history) {
  var pushLandingHistory = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return {
    type: LOGOFF_BACK_NAVIGATION_CONFIRMATION_REQUEST,
    history: history,
    pushLandingHistory: pushLandingHistory
  };
};
export var requestLogoffConfirmation = function requestLogoffConfirmation() {
  return {
    type: LOGOFF_REQUEST_CONFIRMATION
  };
};
export var showLogoffConfirmation = function showLogoffConfirmation() {
  return {
    type: LOGOFF_CONFIRMATION_SHOW
  };
};
export var hideLogoffConfirmation = function hideLogoffConfirmation() {
  return {
    type: LOGOFF_CONFIRMATION_HIDE
  };
};
export var showSessionTimeoutWarning = function showSessionTimeoutWarning(timeoutTime) {
  return {
    type: SESSION_TIMEOUT_WARNING_SHOW,
    timeoutTime: timeoutTime
  };
};
export var dismissSessionTimeoutWarning = function dismissSessionTimeoutWarning() {
  return {
    type: SESSION_TIMEOUT_WARNING_DISMISS
  };
};
export var hideSessionTimeoutWarning = function hideSessionTimeoutWarning() {
  return {
    type: SESSION_TIMEOUT_WARNING_HIDE
  };
};